import {getQueryString, localRead} from "@/utils/tools";

/**
 * mis后台数据特殊字段的隐藏处理
 */
export default {
    isAuth:(value)=>{
      let menus = [];
      if (window.SITE_CONFIG['routerLabel']) {
        let label = window.SITE_CONFIG['routerLabel'];
        menus = JSON.parse(localRead(label + '_buttons'));
      } else if (window.location.href.indexOf('label') != -1) {
        let label = getQueryString('label');
        menus = JSON.parse(localRead(label + '_buttons'));
      }
      if (value != null && value != '') {
        for (var i in menus) {
          if (menus[i].path == value) return true;
        }
      } else {
        return true;
      }
      return false;
    },
   /**
   * 手机号转换
   * @param auth  导出按钮权限标识
   * @param value  手机号
   * @returns {string|*}
   */
    hidePhone:(auth,data)=>{
       if (this.isAuth(auth)){
          return data;
       }else{
          return data != null?data.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2"):"";
       }
    },

  /**
   * 姓名转换
   * @param auth  导出按钮权限标识
   * @param data  姓名
   * @returns {string|*}
   */
    hideName:(auth,data)=>{
      if (this.isAuth(auth)){
        return data;
      }else{
        if (data == null || data == "") return "";
        return data.length > 2?data.replace(/^.|.$/g, "*"):data.replace(/^./g, "*");
      }
    },

    /**
     * 邮箱转换
     * @param auth  导出按钮权限标识
     * @param value  邮箱
     * @returns {string|*}
     */
    hideEmail:(auth,data)=>{
      if (this.isAuth(auth)){
        return data;
      }else{
        return data != null?data.replace(/(^\w{4})/, "****"):"";
      }
    },

    /**
     * 身份证件转换
     * @param auth  导出按钮权限标识
     * @param value  身份证件
     * @returns {string|*}
     */
    hideIdCard:(auth,data)=>{
      if (this.isAuth(auth)){
        return data;
      }else{
        return data != null?data.replace(/(\w{6}$)/, "******"):"";
      }
    },

}
